var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccessMail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 48,
    fill: "#007E33"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.25 63L47.1667 55.9167L49.5 53.5833L54.25 58.3333L63.6667 48.9167L66 51.25L54.25 63ZM47.6667 44.6667L61 36.3333H34.3333L47.6667 44.6667ZM47.6667 48L34.3333 39.6667V56.3333H42.9167L46.25 59.6667H34.3333C33.4167 59.6667 32.6319 59.3403 31.9792 58.6875C31.3264 58.0347 31 57.25 31 56.3333V36.3333C31 35.4167 31.3264 34.6319 31.9792 33.9792C32.6319 33.3264 33.4167 33 34.3333 33H61C61.9167 33 62.7014 33.3264 63.3542 33.9792C64.0069 34.6319 64.3333 35.4167 64.3333 36.3333V43.5833L61 46.9167V39.6667L47.6667 48Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessMail);
export default __webpack_public_path__ + "static/media/SuccessMail.d802fa86fb6853ea29af85c74c8746b6.svg";
export { ForwardRef as ReactComponent };